import $ from 'jquery'
import './index.styl'

const tpl = (state, title, opt={}) => `
    ${opt.modal?`<div class="cd-confirm-modal">`:''}
        <div class="cd-confirm ${state}">
            <div class="close close-btn"></div>
            <div class="icon"></div>
            ${title?`<div class="title">${title}</div>`:''}
            ${opt.description?`<div class="description">${opt.description}</div>`:''}
            <div class="button-group">
                ${opt.buttons?opt.buttons:`<button class="close">OK</button>`}
            </div>
        </div>
    ${opt.modal?`</div>`:''}
`

function show(...args){
    var content = $(tpl(...args)).hide()
    $("body").append(content)
    content.fadeIn()
    $(content).find(".close").on("click",()=>{
        content.fadeOut(()=>{
			content.remove()
		})
    })
}

export default {
    success(...args) {
        show("success",...args)
    },
    warning(...args) {
        show("warning",...args)
    },
}